import { expValEquals } from '@confluence/feature-experiments';
import { useQueryNoFurtherUpdateInterop } from '@confluence/apollo-relay-interop/entry-points/useQueryNoFurtherUpdateInterop.ts';
import { useQueryInterop } from '@confluence/apollo-relay-interop/entry-points/useQueryInterop.ts';

import { WebPanelLocationQuery, useWebPanelLocationBatchResult } from './WebPanelLocation.tsx';
import type {
	WebPanelLocationQuery$data,
	WebPanelLocationQuery$variables,
} from './__generated__/WebPanelLocationQuery.graphql.ts';

export const useConnectAppsData = ({
	contentId,
	location,
}: {
	contentId: string;
	location: string;
}) => {
	const batchResult = useWebPanelLocationBatchResult(location);
	const baseOptions = {
		variables: {
			contentId,
			location,
		},
		skip: Boolean(batchResult),
	};

	// eslint-disable-next-line graphql-client-usage/graphql-generic-types
	const { data } = expValEquals('confluence_stop_watching_webpanellocationquery', 'isEnabled', true)
		? // eslint-disable-next-line react-hooks/rules-of-hooks
			useQueryNoFurtherUpdateInterop<WebPanelLocationQuery$data, WebPanelLocationQuery$variables>(
				WebPanelLocationQuery,
				baseOptions,
			)
		: // eslint-disable-next-line react-hooks/rules-of-hooks
			useQueryInterop<WebPanelLocationQuery$data, WebPanelLocationQuery$variables>(
				WebPanelLocationQuery,
				{
					...baseOptions,
					fetchPolicy: 'cache-first',
				},
			);
	const panels = batchResult?.data?.webPanels || data?.webPanels || [];
	return panels.map((panel) => panel?.moduleKey).join(',');
};
